import src from './src/Sender.vue'

const install = function (Vue) {
  Vue.component(src.name, src)
}

export default {
  install
}
